// extracted by mini-css-extract-plugin
export var checkbox = "skuStyles-module--checkbox--8e4f2";
export var configurationReminder = "skuStyles-module--configurationReminder--70fa1";
export var configurationReminderWrapper = "skuStyles-module--configurationReminderWrapper--40789";
export var customWrapper = "skuStyles-module--customWrapper--989bd";